<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <v-card>
            <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
                <v-flex xs10>
                    <v-btn fab x-small @click="$router.go(-1)">
                        <v-icon>navigate_before</v-icon>
                    </v-btn>
                </v-flex>

                <v-flex xs2>
                  <report-list-actions
                  :reportOptions="reportOptions"
                  :downloadFilename="reportListFilename"
                  ></report-list-actions>
                </v-flex>

                <v-flex xs12>
                    <h3 class="text-center mb-5">EVV Report</h3>
                    <v-divider class="ml-4 mr-4 mb-3"></v-divider>

                </v-flex>

                <v-flex xs12>
                    <v-card
                        class="ma-3 pa-3"
                        elevation="0"
                    >
                        <v-layout row wrap>
                            <v-flex xs12 md4 class="pa-1 mb-2">
                                <v-select
                                  label="Client Status"
                                  :items="clientStatuses"
                                  v-model="reportFilters.clientStatus"
                                  clearable
                                  @change="getEvvResult()"
                                  ></v-select>
                            </v-flex>

                            <v-flex xs12 md4 class="pa-1 mb-2">
                                <v-select
                                    label="Select Service Code"
                                    :items="codes"
                                    item-text="Code"
                                    item-value="Code"
                                    v-model="reportFilters.ServiceCode"
                                    clearable
                                    @change="getEvvResult()"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 md4 class="pa-1 mb-2">
                                <v-select
                                    label="Select a Client"
                                    :items="filteredClients"
                                    item-text="Name"
                                    item-value="._id"
                                    v-model="reportFilters.ClientID"
                                    clearable
                                    @change="getEvvResult()"
                                ></v-select>

                            </v-flex>
                            
                            <v-flex xs12 md4 class="pa-1">
                                <v-menu
                                    ref="calendarMenu"
                                    v-model="calendarMenu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="reportFilters.startDate"
                                            label="Start Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules='requiredField'
                                            clearable
                                            @change="getEvvResult()"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="reportFilters.startDate"
                                        no-title
                                        scrollable
                                        :rules='requiredField'

                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="calendarMenu = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.calendarMenu.save(date)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>

                            </v-flex>

                            <v-flex xs12 md4 class="pa-1">
                                <v-menu
                                    ref="calendar2Menu"
                                    v-model="calendar2Menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="reportFilters.endDate"
                                            label="End Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            :rules='requiredField'
                                            clearable
                                            @change="getEvvResult()"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="reportFilters.endDate"
                                        no-title
                                        scrollable
                                        :rules='requiredField'
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="calendar2Menu = false"
                                        >
                                            Cancel
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.calendar2Menu.save(date)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 md1 class="mt-5 mb-5 pl-5">
                                <v-btn small @click="getEvvResult()">Search</v-btn>
                            </v-flex>
                            
                            <v-flex xs12 md1 class="mt-5 mb-5 pl-5">
                                <v-btn small @click="downloadevvResults()" class="ml-2">Download</v-btn>
                            </v-flex>
                          
                        </v-layout>
                    </v-card>
                </v-flex>


                <v-flex xs12 class="pa-2">
                    <v-data-table
                        :headers="headers"
                        :items="evvResults"
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading EVV Report"
                    />
                </v-flex>
            </v-layout>
        </v-card>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import ReportListActions  from '@/components/Report/ReportListActions.vue';
    import { STATUS_ARRAY } from '../../enums/UserStatusEnum';
    import ReportFilters from '@/mixins/reportFilters.js';
    // import Foot from '../components/Footer'

    const url = require("../../client_config/config").url;
    //const HttpService = require("../../service/http.service");

    export default {
        mixins: [
            ReportFilters,
        ],
        components: {
            ReportListActions
        },
        data: () => ({
            headers: [
                {text: 'Member ID', align: 'start', value: 'MID'},
                {text: "First name", value: "FirstName"},
                {text: "Last name", value: "LastName"},
                {text: "Service Code", value: "ServiceCode"},
                {text: "Service Description", value: "ServiceDescription"},
                {text: "Provider ID", value: "PID"},
                {text: "Employee Performing Service", value: "EmployeeName"},
                {text: "Begin Date", value: "BeginDate"},
                {text: "Begin Time", value: "BeginTime"},
                {text: "Begin Address", value: "BeginAddress"},
                {text: "Begin City", value: "BeginCity"},
                {text: "End Date", value: "EndDate"},
                {text: "End Time", value: "EndTime"},
                {text: "End Address", value: "EndAddress"},
                {text: "End City", value: "EndCity"},
                {text: "Orig_receipt_id", value: ""},
                {text: "Batch_id", value: ""},
                {text: "Record_id", value: ""}  
                // { text: "Actions", value: "actions", sortable: false }
            ],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            // page: 'Incidents',
            clients: [],
            clientIds: [],
            evvResults: [],
            calendarMenu: false,
            calendar2Menu: false,
            report: '',
            clientName: '',
            isLoading: false,
            requiredField: [
                v => !!v || 'This is required',
            ],
            isServiceCodeDisabled: false,
            userState: localStorage.getItem('userState'),
            dialog: false,
            editevvResults: false,
            newevvResults: false,
            msg: false,
            snackbarColor: "black",
            search: "",
            text: "",
            codes: [],
            users: [],
            userID: localStorage.getItem('userID'),
            staff: localStorage.getItem('Name'),
            tempData: [],
            titleForm: "New EVV Record",
            attendanceID: "",
            newName: "",
            newCode: "",
            newDate: "",
            newSignature: "",
            Rate: "",
            signed: false,
            checkSignature: false,
            newUnits: "",
            newServiceUnit: "",
            requiredRules: [
                v => !!v || 'This is required',
            ],
            timeStartPicker: false,
            timeStart: null,
            timeEndPicker: false,
            timeEnd: null,
            timeEndAdjust: null,
            requiredTime: false,
            newServiceCodeDialog: false,
            newServiceCodeAdd: "",
            maskDate: [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
            maskTimeStart: [/[1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[A,P]/, 'M'],
            maskTimeEnd: [/[1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[A,P]/, 'M'],
            showStartTimePicker: false,
            showEndTimePicker: false,
            timeStartDisplay: '',
            timeEndDisplay: '',
            menu: false,
            clientState: "",
            page: 1,
            pageCount: 1,
            itemCount: 0,
            options: {},
            attrs: '',
            on: '',
            clientStatuses: STATUS_ARRAY,
            reportListFilename: 'EVV Report',
            reportFilters:  {
                clientStatus: '',
                ServiceCode: '',
                ClientID: '',
                startDate: '',
                endDate: '',
            },
            reportFilterName: 'ReportFilters_EVV',
        }),

        computed: {
            filteredClients() {
                let clients = this.clients;
                const clientStatus = this.reportFilters.clientStatus;
                
                if (clientStatus != "" && clientStatus) {
                    clients = clients.filter((client) => client.Status == clientStatus)
                }
                
                if (this?.ServiceCode != "" && this.ServiceCode) {
                    clients = clients.filter((client) => {
                        if (client.ServiceCode?.length > 0) {
                            return client.ServiceCode.indexOf(this.ServiceCode) > -1 ? true: false;
                        }
                    })
                }
                
                return clients;
            },
            
      

        queryParams() {
            let {page, sortBy, sortDesc, itemsPerPage} = this.options;      
            const sortField = sortBy ? sortBy[0] : 'Date';
            const sortDirection = sortDesc ? sortDesc[0] : 'desc';
    
            return {
                clientId: this.reportFilters.ClientID,
                StartDate: this.reportFilters.startDate,
                EndDate: this.reportFilters.endDate,
                ServiceCode: this.reportFilters.ServiceCode,
                clientStatus: this.reportFilters.clientStatus,
                sortField: sortField,
                sortDirection: sortDirection,
                page: page,
                limit: itemsPerPage,
            };
        },
    
        reportOptions() {
            return { 
                query: this.queryParams,
                endpoints: `payroll/print-pdf`,
                dynamic: true
            }
        }
        },        

        watch: {
            reportFilters: {
                handler(newVal) {
                this.setReportFilters(this.reportFilterName, newVal);
                },
                deep: true
            }
        },

        created() {
            this.getClients();
            this.getEvvResult();
            this.getCodes();
            this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
        },

        methods: {
            initialize() {
                this.clients = [];
            },

            getClients() {
                // this.state = this.userState || '';

                axios.get(`${url}/clients`).then(async res => {
                    this.clients = res.data.clients || [];
                    this.clientIds = this.clients.map(client => client._id);
                    this.clients.unshift({
                        _id: 'All',
                        Name: 'All Clients'
                    });
                });

                // DEPRECATED CODE
                // axios.get(`${url}/clients/state/${this.state}`).then(async res => {
                //     this.clients = res.data.clients || [];
                //     this.clientIds = this.clients.map(client => client._id);
                //     this.clients.unshift({
                //         _id: 'All',
                //         Name: 'All Clients'
                //     });
                // });
            },
            getClientState() {
                axios.get(`${url}/clients/${this.reportFilters.ClientID}`).then(res => {
                    this.clientState = res.data.client.State;
                })
            },

            getClientServiceCode(){
                axios.get(`${url}/serviceCodes/get/allClientCodes/${this.reportFilters.ClientID}`).then(res => {
                    this.codes = res.data.serviceCodes;
                })
            },

            getCodes: function() {
                this.isLoading = true;
                axios.get(`${url}/codes`).then(res => {
                    this.codes = res.data.codes;
                }).finally(() => this.isLoading = false);
            },

            getEvvResult() {
                this.isLoading = true;
                this.evvResults = [];
                const params = {
                    ...this.queryParams
                };

                axios.post(`${url}/payroll/evvReport`, params)
                .then(response => {
                    this.evvResults = [];
                    response.data.timesheets.forEach((value) => {
                    
                    value.BeginDate = moment(new Date(value.ClockIn)).format("M/D/YYYY");
                    value.BeginTime = moment(new Date(value.ClockIn)).format("H:MM");

                    if(value.LocationIn?.length > 0){
                        value.BeginAddress = value.LocationIn[0].Street;
                        value.BeginCity = value.LocationIn[0].City;
                    }

                    value.EndDate = moment(new Date(value.ClockOut)).format("M/D/YYYY");
                    value.EndTime = moment(new Date(value.ClockOut)).format("H:MM");
                        if(value.LocationOut?.length > 0){
                        value.EndAddress = value.LocationOut[0].Street;
                        value.EndCity = value.LocationOut[0].City;
                    }
                    
                    this.evvResults.push(value);
                    });

                })
                .catch(error => {
                    console.log({error});
                })
                .finally(() => {
                    this.isLoading = false
                });
                
            },

            downloadevvResults() {
                const validationMessage = this.validateevvResultsDownload();
                if (validationMessage) {
                    alert(`Failed to download evvResults. ${validationMessage}`);
                    return;
                }
                window.location.href = `${url}/payroll/downloadEvv?defaultClientIds=${this.clientIds}&clientId=${this.reportFilters.ClientID}&StartDate=${this.reportFilters.startDate}&EndDate=${this.reportFilters.endDate}&ServiceCode=${this.reportFilters.ServiceCode}`;
            },

            validateevvResultsDownload() {
                if (!this.reportFilters.startDate) {
                    return 'Start date is required.';
                }

                if (!this.reportFilters.endDate) {
                    return 'End date is required.';
                }

                // if (!this.reportFilters.clientIds) {
                //     return 'Client ids is required.';
                // }
                //
                // if (!this.ServiceCode) {
                //     return 'Service code is required.';
                // }

                return '';
            },

            getClientID(item) {
                this.client = item.ClientID;
                window.localStorage.setItem('clientId', this.client)
                console.log(this.client)
            },

            close() {
                this.dialog = false;
                this.requiredTime = false;
                this.resetForm();
            },
            resetForm() {
                this.newName = "";
                this.newCode = "";
                this.newDate = "";
                this.newSignature = "";
                this.newUnits = "";
                this.newServiceUnit = "";
                this.signed = false;
                this.timeStart = null;
                this.timeEnd = null;
            },
        }
    }
</script>
<style>
    #print {
        display: none
    }

    @media only screen and (min-width: 768px) {
        .mobile {
            display: none;
        }
    }

    @media only screen and (max-width: 600px) {
        .desktop {
            display: none;
        }
    }

    @media only screen and (min-width: 768px) {
        .mobile {
            display: none;
        }
    }

    @media only screen and (max-width: 600px) {
        .desktop {
            display: none;
        }
    }

    @media print {
        #print {
            display: block;
            border: none;
            width: 1200px;
            padding-right: 300px;
            margin-left: -200px;
        }

        nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
            display: none;
            border: none;
        }

        @page {
            margin: 0;
        }

        body {
            margin: 1.6cm;
        }
    }
</style>
